import CircularProgress from "@material-ui/core/CircularProgress";
import { ArrowBack, Business, RefreshOutlined } from "@material-ui/icons";
import millify from "millify";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Chart from "react-google-charts";
import Select from "react-select";
import styled from "styled-components";
import fetchClient from "../../api/fetchClient";
import Tile from "../../components/Tile";
import message from "../../helper/message";

const Loading = () => (
  <LoadingContainer>
    <CircularProgress size={16} color='white' style={{ opacity: '1 !important' }} />
  </LoadingContainer>
)

function DashBoard() {
  const history = useHistory();
  const [id, setId] = useState();

  const [isLoadingEmpresa, setIsLoadingEmpresa] = useState(false);

  const [isLoadingNFSe30days, setIsLoadingNFSe30days] = useState(false);
  const [isLoadingNFSe7days, setIsLoadingNFSe7days] = useState(false);
  const [isLoadingNFSe24hours, setIsLoadingNFSe24hours] = useState(false);

  const [quantityNFSe30days, setQuantityNFSe30days] = useState("");
  const [quantityNFSe7days, setQuantityNFSe7days] = useState("");
  const [quantityNFSe24hours, setQuantityNFSe24hours] = useState("");

  const [isLoadingPedidoCompra30days, setIsLoadingPedidoCompra30days] = useState(false);
  const [isLoadingPedidoCompra7days, setIsLoadingPedidoCompra7days] = useState(false);
  const [isLoadingPedidoCompra24hours, setIsLoadingPedidoCompra24hours] = useState(false);

  const [quantityPedidoCompra30days, setQuantityPedidoCompra30days] = useState("");
  const [quantityPedidoCompra7days, setQuantityPedidoCompra7days] = useState("");
  const [quantityPedidoCompra24hours, setQuantityPedidoCompra24hours] = useState("");

  const [isLoadingPedidoVenda30days, setIsLoadingPedidoVenda30days] = useState(false);
  const [isLoadingPedidoVenda7days, setIsLoadingPedidoVenda7days] = useState(false);
  const [isLoadingPedidoVenda24hours, setIsLoadingPedidoVenda24hours] = useState(false);

  const [quantityPedidoVenda30days, setQuantityPedidoVenda30days] = useState("");
  const [quantityPedidoVenda7days, setQuantityPedidoVenda7days] = useState("");
  const [quantityPedidoVenda24hours, setQuantityPedidoVenda24hours] = useState("");



  const [isLoadingNFe30days, setIsLoadingNFe30days] = useState(false);
  const [isLoadingNFe7days, setIsLoadingNFe7days] = useState(false);
  const [isLoadingNFe24hours, setIsLoadingNFe24hours] = useState(false);
  const [quantityNFe30days, setQuantityNFe30days] = useState("");
  const [quantityNFe7days, setQuantityNFe7days] = useState("");
  const [quantityNFe24hours, setQuantityNFe24hours] = useState("");

  const [isLoadingItemsLastMonth, setIsLoadingItemsLastMonth] = useState(false);
  const [quantityItemsLastMonth, setQuantityItemsLastMonth] = useState("");

  const [isLoadingCliente15days, setIsLoadingCliente15days] = useState(false);
  const [quantityCliente15days, setQuantityCliente15days] = useState("");

  const [isLoadingFornecedor15days, setIsLoadingFornecedor15days] =
    useState(false);
  const [quantityFornecedor15days, setQuantityFornecedor15days] = useState("");

  const [isLoadingContasPagar30days, setIsLoadingContasPagar30days] =
    useState(false);
  const [quantityContasPagar30days, setQuantityContasPagar30days] =
    useState("");

  const [isLoadingContasReceber30days, setIsLoadingContasReceber30days] =
    useState(false);
  const [quantityContasReceber30days, setQuantityContasReceber30days] =
    useState("");

  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState();

  const [chartType, setChartType] = useState({ value: "all", label: "Todos" });
  const [days, setDays] = useState({ value: 15, label: "15 dias" });
  const [linechart, setLinechart] = useState(null);
  const [isLoadingCharts, setIsLoadingCharts] = useState(false);

  const getAllEmpresas = () => {
    setIsLoadingEmpresa(true);
    fetchClient
      .get("/seidor/aplicacao/getAllAplicacao")
      .then(({ data }) => {
        const aplicacoes = data
          .filter((app) => app.type === "dashboard" || app.type === "todos")
          .map((app) => {
            return { value: app.id, label: app.description };
          });
        setOptions(aplicacoes);
        setIsLoadingEmpresa(false);
      })
      .catch((error) => {
        setIsLoadingEmpresa(false);
        console.log(error)
        message.error(error.response.data.message);
      });
  };

  const getQuantityItemsLastMonth = () => {
    setIsLoadingItemsLastMonth(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityItemsLastMonth/${id}`)
      .then(({ data }) => {
        setQuantityItemsLastMonth(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingItemsLastMonth(false);
      })
      .catch((error) => {
        setQuantityItemsLastMonth("");
        setIsLoadingItemsLastMonth(false);
        message.error(error.response.data.message);
      });
  };

  const getQuantiyContasPagar30days = () => {
    setIsLoadingContasPagar30days(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityContasPagar/${id}/30`)
      .then(({ data }) => {
        setQuantityContasPagar30days(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingContasPagar30days(false);
      })
      .catch((error) => {
        setQuantityContasPagar30days("");
        setIsLoadingContasPagar30days(false);
        message.error(error.response.data.message);
      });
  };

  const getQuantiyContasReceber30days = () => {
    setIsLoadingContasReceber30days(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityContasReceber/${id}/30`)
      .then(({ data }) => {
        setQuantityContasReceber30days(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingContasReceber30days(false);
      })
      .catch((error) => {
        setQuantityContasReceber30days("");
        setIsLoadingContasReceber30days(false);
        message.error(error.response.data.message);
      });
  };

  const getQuantiyCliente15days = () => {
    setIsLoadingCliente15days(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityClientes/${id}/15`)
      .then(({ data }) => {
        setQuantityCliente15days(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingCliente15days(false);
      })
      .catch((error) => {
        setQuantityCliente15days("");
        setIsLoadingCliente15days(false);
        message.error(error.response.data.message);
      });
  };

  const getQuantiyFornecedor15days = () => {
    setIsLoadingFornecedor15days(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityFornecedores/${id}/15`)
      .then(({ data }) => {
        setQuantityFornecedor15days(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingFornecedor15days(false);
      })
      .catch((error) => {
        setQuantityFornecedor15days("");
        setIsLoadingFornecedor15days(false);
        message.error(error.response.data.message);
      });
  };

  const getQuantiyNFSe30days = () => {
    setIsLoadingNFSe30days(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityNFSe/${id}/30`)
      .then(({ data }) => {
        setQuantityNFSe30days(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingNFSe30days(false);
      })
      .catch((error) => {
        setQuantityNFSe30days("");
        setIsLoadingNFSe30days(false);
        message.error(error.response.data.message);
      });
  };

  const getQuantiyNFe30days = () => {
    setIsLoadingNFe30days(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityNFe/${id}/30`)
      .then(({ data }) => {
        setQuantityNFe30days(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingNFe30days(false);
      })
      .catch((error) => {
        setQuantityNFe30days("");
        setIsLoadingNFe30days(false);
        message.error(error.response.data.message);
      });
  };

  const getQuantiyPedidoCompra30days = () => {
    setIsLoadingPedidoCompra30days(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityPedidoCompra/${id}/30`)
      .then(({ data }) => {
        setQuantityPedidoCompra30days(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingPedidoCompra30days(false);
      })
      .catch((error) => {
        setQuantityPedidoCompra30days("");
        setIsLoadingPedidoCompra30days(false);
        message.error(error.response.data.message);
      });
  };

  const getQuantiyPedidoVenda30days = () => {
    setIsLoadingPedidoVenda30days(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityPedidoVenda/${id}/30`)
      .then(({ data }) => {
        setQuantityPedidoVenda30days(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingPedidoVenda30days(false);
      })
      .catch((error) => {
        setQuantityPedidoVenda30days("");
        setIsLoadingPedidoVenda30days(false);
        message.error(error.response.data.message);
      });
  };

  const getQuantiyNFSe7days = () => {
    setIsLoadingNFSe7days(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityNFSe/${id}/7`)
      .then(({ data }) => {
        setQuantityNFSe7days(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingNFSe7days(false);
      })
      .catch((error) => {
        setQuantityNFSe7days("");
        setIsLoadingNFSe7days(false);
        message.error(error.response.data.message);
      });
  };

  const getQuantiyNFe7days = () => {
    setIsLoadingNFe7days(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityNFe/${id}/7`)
      .then(({ data }) => {
        setQuantityNFe7days(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingNFe7days(false);
      })
      .catch((error) => {
        setQuantityNFe7days("");
        setIsLoadingNFe7days(false);
        message.error(error.response.data.message);
      });
  };

  const getQuantiyPedidoCompra7days = () => {
    setIsLoadingPedidoCompra7days(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityPedidoCompra/${id}/7`)
      .then(({ data }) => {
        setQuantityPedidoCompra7days(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingPedidoCompra7days(false);
      })
      .catch((error) => {
        setQuantityPedidoCompra7days("");
        setIsLoadingPedidoCompra7days(false);
        message.error(error.response.data.message);
      });
  };

  const getQuantiyPedidoVenda7days = () => {
    setIsLoadingPedidoVenda7days(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityPedidoVenda/${id}/7`)
      .then(({ data }) => {
        setQuantityPedidoVenda7days(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingPedidoVenda7days(false);
      })
      .catch((error) => {
        setQuantityPedidoVenda7days("");
        setIsLoadingPedidoVenda7days(false);
        message.error(error.response.data.message);
      });
  };


  const getQuantiyNFSe24hours = () => {
    setIsLoadingNFSe24hours(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityNFSe/${id}/1`)
      .then(({ data }) => {
        setQuantityNFSe24hours(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingNFSe24hours(false);
      })
      .catch((error) => {
        setQuantityNFSe24hours("");
        setIsLoadingNFSe24hours(false);
        message.error(error.response.data.message);
      });
  };

  const getQuantiyNFe24hours = () => {
    setIsLoadingNFe24hours(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityNFe/${id}/1`)
      .then(({ data }) => {
        setQuantityNFe24hours(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingNFe24hours(false);
      })
      .catch((error) => {
        setQuantityNFe24hours("");
        setIsLoadingNFe24hours(false);
        message.error(error.response.data.message);
      });
  };

  const getQuantiyPedidoCompra24hours = () => {
    setIsLoadingPedidoCompra24hours(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityPedidoCompra/${id}/1`)
      .then(({ data }) => {
        setQuantityPedidoCompra24hours(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingPedidoCompra24hours(false);
      })
      .catch((error) => {
        setQuantityPedidoCompra24hours("");
        setIsLoadingPedidoCompra24hours(false);
        message.error(error.response.data.message);
      });
  };

  const getQuantiyPedidoVenda24hours = () => {
    setIsLoadingPedidoVenda24hours(true);
    fetchClient
      .get(`seidor/aplicacao/getQuantityPedidoVenda/${id}/1`)
      .then(({ data }) => {
        setQuantityPedidoVenda24hours(
          millify(data, {
            precision: 2,
            decimalSeparator: ",",
          })
        );
        setIsLoadingPedidoVenda24hours(false);
      })
      .catch((error) => {
        setQuantityPedidoVenda24hours("");
        setIsLoadingPedidoVenda24hours(false);
        message.error(error.response.data.message);
      });
  };

  const handleChange = (selected) => {
    setSelectedOption(selected);
    setId(selected.value);
  };

  const loadDataTiles = () => {
    if (id) {
      getQuantiyNFSe30days();
      getQuantiyNFSe7days();
      getQuantiyNFSe24hours();

      getQuantiyNFe30days();
      getQuantiyNFe7days();
      getQuantiyNFe24hours();

      getQuantiyPedidoCompra30days();
      getQuantiyPedidoCompra7days();
      getQuantiyPedidoCompra24hours();

      getQuantiyPedidoVenda30days();
      getQuantiyPedidoVenda7days();
      getQuantiyPedidoVenda24hours();

      getQuantityItemsLastMonth();

      getQuantiyCliente15days();
      getQuantiyFornecedor15days();

      getQuantiyContasPagar30days();
      getQuantiyContasReceber30days();
    }
  };

  const loadChartData = async () => {
    setLinechart(null);
    setIsLoadingCharts(true);

    try {
      var results;
      if (chartType.value === "all") {

        var responseCR, responseCP, responseLCM = null;

        const [
          resonseNF,
          resonseNFS,
          resonseItems,
          resonseFornecedores,
          responsePedidoCompra,
          responsePedidoVenda,
        ] = await Promise.all([
          fetchClient.get(`/seidor/dashboard/getQuantityNFe/${id}?days=${days.value}`),
          fetchClient.get(`/seidor/dashboard/getQuantityNFSe/${id}?days=${days.value}`),
          fetchClient.get(`/seidor/dashboard/getQuantityItems/${id}?days=${days.value}`),
          fetchClient.get(`/seidor/dashboard/getQuantityFornecedores/${id}?days=${days.value}`),
          fetchClient.get(`/seidor/dashboard/getQuantityPedidoCompra/${id}?days=${days.value}`),
          fetchClient.get(`/seidor/dashboard/getQuantityPedidoVenda/${id}?days=${days.value}`),
        ])

        try {
          responseCP = await fetchClient.get(`/seidor/dashboard/getQuantityContasPagar/${id}?days=${days.value}`)
          responseCR = await fetchClient.get(`/seidor/dashboard/getQuantityContasReceber/${id}?days=${days.value}`)
          responseLCM = await fetchClient.get(`/seidor/dashboard/getQuantityLancamento/${id}?days=${days.value}`)
        } catch (error) {
          console.log(error)
          message.error("Erro ao carregar Contas a Pagar, Contas a Receber e Lançamento Contábil!")
        }

        const labels = [
          { type: "date", label: "Dia" },
          "NF-e/ NFS-e",
          "NF",
          "Items",
          "Fornecedores",
          "Pedidos de Compra",
          "Pedidos de Venda"
        ]

        if (responseCP) labels.push("Contas à Pagar")
        if (responseCR) labels.push("Contas à Receber")
        if (responseLCM) labels.push("Lançamentos Contabeis")

        results = [
          labels,
          ...resonseNFS.data.map((value, index) => {

            const datas = [
              new Date(value.day),
              value.count,
              resonseNF.data[index].count,
              resonseItems.data[index].count,
              resonseFornecedores.data[index].count,
              responsePedidoCompra.data[index].count,
              responsePedidoVenda.data[index].count,
            ]

            if (responseCP) datas.push(responseCP.data[index].count)
            if (responseCR) datas.push(responseCR.data[index].count)
            if (responseLCM) datas.push(responseLCM.data[index].count)

            return datas;

          })
        ];

      } else {
        const response = await fetchClient.get(`/seidor/dashboard/getQuantity${chartType.value}/${id}?days=${days.value}`)

        results = [
          [
            { type: "date", label: "Dia" },
            chartType.label,
          ],
          ...response.data.map((value) => [new Date(value.day), value.count])
        ];
      }


      console.log("results")
      console.log(results)

      setLinechart(results);

    } catch (error) {

      console.log(error);
      message.error(error.response?.data.message || error.message)

    } finally {
      setIsLoadingCharts(false);
    }


  }

  const refreshDashboard = () => {
    loadDataTiles();
    loadChartData();
  };

  useEffect(() => {
    getAllEmpresas();
  }, []);

  useEffect(() => {
    loadDataTiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (days && chartType && id)
      loadChartData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, days, chartType]);



  return (
    <Page>
      <ModernHeader>
        <HeaderLeft>
          <BackButton onClick={() => history.goBack()}>
            <ArrowBack />
          </BackButton>
          <HeaderContent>
            <HeaderTitle>
              <Business style={{ marginRight: "12px", fontSize: "32px" }} />
              Dashboard Seidor
            </HeaderTitle>
            <HeaderSubtitle>Monitore indicadores e gráficos do portal</HeaderSubtitle>
          </HeaderContent>
        </HeaderLeft>
        <HeaderActions>
          <HeaderActionButton
            variant="secondary"
            onClick={refreshDashboard}
            disabled={isLoadingCharts || isLoadingEmpresa}
          >
            <RefreshOutlined />
            {isLoadingCharts || isLoadingEmpresa ? "Atualizando..." : "Atualizar painel"}
          </HeaderActionButton>
        </HeaderActions>
      </ModernHeader>

      <ContentCard>
        <ContainerTop>
          <ContainerSelect>
            <Select
              value={selectedOption}
              className="basic-single"
              placeholder="Empresa"
              isSearchable={true}
              name="empresas"
              options={options}
              onChange={handleChange}
              isLoading={isLoadingEmpresa}
            />
          </ContainerSelect>
          <ContainerButton onClick={refreshDashboard}>
            <RefreshOutlined />
            <TitleButton>Refresh</TitleButton>
          </ContainerButton>
        </ContainerTop>
        <SectionHeading>Indicadores principais</SectionHeading>
        <ContainerContent>
          <Tile
            quantity={quantityNFe30days}
            image={"/image/icon_in.png"}
            title="Quantidade NF de entrada nos últimos 30 dias"
            isLoading={isLoadingNFe30days}
          />

          <Tile
            quantity={quantityNFe7days}
            image={"/image/icon_in.png"}
            title="Quantidade NF de entrada nos últimos 7 dias"
            isLoading={isLoadingNFe7days}
          />

          <Tile
            quantity={quantityNFe24hours}
            image={"/image/icon_in.png"}
            title="Quantidade NF de entrada nas últimas 24 horas"
            isLoading={isLoadingNFe24hours}
          />

          <Tile
            quantity={quantityNFSe30days}
            image={"/image/icon_out.png"}
            title="Quantidade NF-e / NFS-e emitidos nos últimos 30 dias"
            isLoading={isLoadingNFSe30days}
          />

          <Tile
            quantity={quantityNFSe7days}
            image={"/image/icon_out.png"}
            title="Quantidade NF-e / NFS-e emitidos nos últimos 7 dias"
            isLoading={isLoadingNFSe7days}
          />

          <Tile
            quantity={quantityNFSe24hours}
            image={"/image/icon_out.png"}
            title="Quantidade NF-e / NFS-e emitidos nas últimas 24 horas"
            isLoading={isLoadingNFSe24hours}
          />

          <Tile
            quantity={quantityPedidoCompra30days}
            image={"/image/compra.png"}
            title="Quantidade Pedido de Compra emitidos nos últimos 30 dias"
            isLoading={isLoadingPedidoCompra30days}
          />

          <Tile
            quantity={quantityPedidoCompra7days}
            image={"/image/compra.png"}
            title="Quantidade Pedido de Compra emitidos nos últimos 7 dias"
            isLoading={isLoadingPedidoCompra7days}
          />

          <Tile
            quantity={quantityPedidoCompra24hours}
            image={"/image/compra.png"}
            title="Quantidade Pedido de Compra emitidos nas últimas 24 horas"
            isLoading={isLoadingPedidoCompra24hours}
          />

          <Tile
            quantity={quantityPedidoVenda30days}
            image={"/image/venda.png"}
            title="Quantidade Pedido de Venda emitidos nos últimos 30 dias"
            isLoading={isLoadingPedidoVenda30days}
          />

          <Tile
            quantity={quantityPedidoVenda7days}
            image={"/image/venda.png"}
            title="Quantidade Pedido de Venda emitidos nos últimos 7 dias"
            isLoading={isLoadingPedidoVenda7days}
          />

          <Tile
            quantity={quantityPedidoVenda24hours}
            image={"/image/venda.png"}
            title="Quantidade Pedido de Venda emitidos nas últimas 24 horas"
            isLoading={isLoadingPedidoVenda24hours}
          />

          <Tile
            quantity={quantityItemsLastMonth}
            image={"/image/iconitens.png"}
            title="Quantidade Items cadastrado no último mês"
            isLoading={isLoadingItemsLastMonth}
          />

          <Tile
            quantity={quantityCliente15days}
            image={"/image/iconvendas.png"}
            title="Quantidade Clientes cadastrados nos últimos 15 dias"
            isLoading={isLoadingCliente15days}
          />

          <Tile
            quantity={quantityFornecedor15days}
            image={"/image/iconfornecedor.png"}
            title="Quantidade Fornecedores cadastrados nos últimos 15 dias"
            isLoading={isLoadingFornecedor15days}
          />

          <Tile
            quantity={quantityContasPagar30days}
            image={"/image/iconcp.png"}
            title="Quantidade contas a pagar em aberto para os próximos 30 dias"
            isLoading={isLoadingContasPagar30days}
          />

          <Tile
            quantity={quantityContasReceber30days}
            image={"/image/iconcr.png"}
            title="Quantidade contas a receber em aberto para os próximos 30 dias"
            isLoading={isLoadingContasReceber30days}
          />
        </ContainerContent>
        <ContainerChart>
          <Title>Gráficos de Uso</Title>
          <ContainerSelects>
            <ContainerSelect>
              <Select
                value={chartType}
                className="basic-single"
                placeholder="Tipo de Dado"
                isSearchable={true}
                name="chartType"
                options={[
                  { value: "all", label: "Todos" },
                  { value: "nfe", label: "NF-e" },
                  { value: "nfse", label: "NFSe" },
                  { value: "items", label: "Itens" },
                  { value: "fornecedores", label: "Fornecedores" },
                  { value: "pedidocompra", label: "Pedidos de Compra" },
                  { value: "pedidovenda", label: "Pedidos de Venda" },
                  { value: "contaspagar", label: "Contas a Pagar" },
                  { value: "contasreceber", label: "Contas a Receber" },
                  { value: "lancamento", label: "Lançamentos" },
                ]}
                onChange={setChartType}
                isLoading={isLoadingEmpresa}
              />
            </ContainerSelect>
            <ContainerSelect>
              <Select
                value={days}
                className="basic-single"
                placeholder="Período em dias"
                isSearchable={true}
                name="days"
                options={[
                  { value: 15, label: "15 dias" },
                  { value: 30, label: "30 dias" },
                  { value: 60, label: "60 dias" },
                  { value: 90, label: "90 dias" },
                ]}
                onChange={setDays}
                isLoading={isLoadingEmpresa}
              />
            </ContainerSelect>
          </ContainerSelects>

          {chartType && days ? (
            isLoadingCharts ? (
              <Loading />
            ) : linechart ? (
              <div style={{ flex: 1, minHeight: 500 }}>
                <Chart
                  chartLanguage="pt-BR"
                  chartType="Line"
                  width="100%"
                  height={500}
                  options={{
                    lenguage: "pt",
                  }}
                  data={linechart}
                />
              </div>
            ) : (
              <NoEvents>SEM DADOS</NoEvents>
            )
          ) : (
            <></>
          )}
        </ContainerChart>
      </ContentCard>
    </Page>
  );
}

export default DashBoard;


const ContainerSelects = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 20px;
`;

const ContainerChart = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  max-width: 100%;
`;

const NoEvents = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 1.5rem;
    font-weight: bold;
    color: #999;
`

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
`;

const Page = styled.div`
  width: 100%;
  min-height: calc(100vh - 65px);
  background-color: #f3f4f6;
  box-sizing: border-box;
`;

const ModernHeader = styled.div`
  max-width: 1200px;
  margin: 0 auto 2.5rem;
  padding: 3rem 2rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 2rem 1rem 0;
  }
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

const BackButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 14px;
  border: none;
  background: rgba(102, 126, 234, 0.1);
  color: #4c1d95;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease, background 0.2s ease;

  &:hover {
    transform: translateX(-2px);
    background: rgba(66, 153, 225, 0.15);
  }

  &:active {
    transform: translateX(0);
  }
`;

const HeaderContent = styled.div`
  flex: 1;
`;

const HeaderTitle = styled.h1`
  font-size: 1.8rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem 0;
  display: flex;
  align-items: center;
  font-family: "Mulish", sans-serif;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const HeaderSubtitle = styled.p`
  margin: 0;
  color: #6b7280;
  font-size: 1rem;
  font-family: "Mulish", sans-serif;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
`;

const headerVariantStyles = {
  primary: `
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #fff;
  `,
  secondary: `
    background: linear-gradient(135deg, #8e44ad 0%, #d35400 100%);
    color: #fff;
  `,
};

const HeaderActionButton = styled.button`
  border: none;
  border-radius: 12px;
  padding: 12px 20px;
  font-weight: 600;
  font-family: "Mulish", sans-serif;
  font-size: 14px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  transition: all 0.25s ease;
  ${({ variant }) =>
    headerVariantStyles[variant] || headerVariantStyles.primary}

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    box-shadow: none;
  }

  &:hover:not(:disabled) {
    transform: translateY(-2px);
  }
`;

const ContentCard = styled.div`
  background: white;
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 24px;
    margin: 0 1rem;
  }
`;

const SectionHeading = styled.h3`
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 700;
  color: #1f2933;
  font-family: "Mulish", sans-serif;
`;

const ContainerContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
`;

const ContainerTop = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #1f2933;
  margin-bottom: 12px;
  font-family: "Mulish", sans-serif;
`;

const ContainerSelect = styled.div`
  flex: 1;
  min-width: 180px;
`;

const ContainerButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  height: 40px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  font-family: "Mulish", sans-serif;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(102, 126, 234, 0.4);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

const TitleButton = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`;
